export const CHANGE_DARK = 'changeDark';
export const CHANGE_LIGHT = 'changeLight';